import React, { Suspense, useEffect, useRef, useState, useMemo } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { useGLTF, useTexture, Loader, Environment, useFBX, useAnimations, OrthographicCamera } from '@react-three/drei';
import { MeshStandardMaterial } from 'three/src/materials/MeshStandardMaterial';

import { LinearEncoding, sRGBEncoding } from 'three/src/constants';
import { LineBasicMaterial, MeshPhysicalMaterial, Vector2 } from 'three';
import ReactAudioPlayer from 'react-audio-player';

import createAnimation from './converter';
import blinkData from './blendDataBlink.json';

import * as THREE from 'three';
import axios from 'axios';

import ReadMoreArea from '@foxeian/react-read-more';

import queryString from 'query-string';

const _ = require('lodash');

const host = 'https://talkingapi.vplaysmart.com'
const chatbothost =  'https://qabotapi.vplaysmart.com'
const vplayhost =  'https://vplaysmart.com'

let SpeechRecognition = window.webkitSpeechRecognition || window.SpeechRecognition
let SpeechGrammarList = window.SpeechGrammarList || window.webkitSpeechGrammarList
let correct_count = 0;
let wrong_count = 0;
let attempts = 0;

function Avatar({ avatar_url, speak, setSpeak, text, setAudioSource, playing }) {

  let gltf = useGLTF(avatar_url);
  let morphTargetDictionaryBody = null;
  let morphTargetDictionaryLowerTeeth = null;

  const [ 
    bodyTexture, 
    eyesTexture, 
    teethTexture, 
    bodySpecularTexture, 
    bodyRoughnessTexture, 
    bodyNormalTexture,
    teethNormalTexture,
    // teethSpecularTexture,
    hairTexture,
    tshirtDiffuseTexture,
    tshirtNormalTexture,
    tshirtRoughnessTexture,
    hairAlphaTexture,
    hairNormalTexture,
    hairRoughnessTexture,
    ] = useTexture([
    "/images/body.webp",
    "/images/eyes.webp",
    "/images/teeth_diffuse.webp",
    "/images/body_specular.webp",
    "/images/body_roughness.webp",
    "/images/body_normal.webp",
    "/images/teeth_normal.webp",
    // "/images/teeth_specular.webp",
    "/images/h_color.webp",
    "/images/tshirt_diffuse.webp",
    "/images/tshirt_normal.webp",
    "/images/tshirt_roughness.webp",
    "/images/h_alpha.webp",
    "/images/h_normal.webp",
    "/images/h_roughness.webp",
  ]);

  _.each([
    bodyTexture, 
    eyesTexture, 
    teethTexture, 
    teethNormalTexture, 
    bodySpecularTexture, 
    bodyRoughnessTexture, 
    bodyNormalTexture, 
    tshirtDiffuseTexture, 
    tshirtNormalTexture, 
    tshirtRoughnessTexture,
    hairAlphaTexture,
    hairNormalTexture,
    hairRoughnessTexture
  ], t => {
    t.encoding = sRGBEncoding;
    t.flipY = false;
  });

  bodyNormalTexture.encoding = LinearEncoding;
  tshirtNormalTexture.encoding = LinearEncoding;
  teethNormalTexture.encoding = LinearEncoding;
  hairNormalTexture.encoding = LinearEncoding;

  
  gltf.scene.traverse(node => {

    //console.log("NODE::::",node)
    if(node.type === 'Mesh' || node.type === 'LineSegments' || node.type === 'SkinnedMesh') {

      node.castShadow = true;
      node.receiveShadow = true;
      node.frustumCulled = false;
     
    
      if (node.name.includes("Wolf3D_Avatar")) {

        // node.castShadow = true;
        // node.receiveShadow = true;

        // node.material = new MeshPhysicalMaterial();
        // node.material.map = bodyTexture;
        // // node.material.shininess = 60;
        // node.material.roughness = 1.7;

        // // node.material.specularMap = bodySpecularTexture;
        // node.material.roughnessMap = bodyRoughnessTexture;
        // node.material.normalMap = bodyNormalTexture;
        // node.material.normalScale = new Vector2(0.6, 0.6);

        morphTargetDictionaryBody = node.morphTargetDictionary;

        //node.material.envMapIntensity = 0.8;
        // node.material.visible = false;

      }

      if (node.name.includes("Eyes")) {
        node.material = new MeshStandardMaterial();
        node.material.map = eyesTexture;
        // node.material.shininess = 100;
        node.material.roughness = 0.1;
        node.material.envMapIntensity = 0.5;


      }

      if (node.name.includes("Brows")) {
        node.material = new LineBasicMaterial({color: 0x000000});
        node.material.linewidth = 1;
        node.material.opacity = 0.5;
        node.material.transparent = true;
        node.visible = false;
      }

      if (node.name.includes("Teeth")) {

        node.receiveShadow = true;
        node.castShadow = true;
        node.material = new MeshStandardMaterial();
        node.material.roughness = 0.1;
        node.material.map = teethTexture;
        node.material.normalMap = teethNormalTexture;

        node.material.envMapIntensity = 0.7;


      }

      if (node.name.includes("Hair")) {
        node.material = new MeshStandardMaterial();
        node.material.map = hairTexture;
        node.material.alphaMap = hairAlphaTexture;
        node.material.normalMap = hairNormalTexture;
        node.material.roughnessMap = hairRoughnessTexture;
        
        node.material.transparent = true;
        node.material.depthWrite = false;
        node.material.side = 2;
        node.material.color.setHex(0x000000);
        
        node.material.envMapIntensity = 0.3;

      
      }

      if (node.name.includes("TSHIRT")) {
        node.material = new MeshStandardMaterial();

        node.material.map = tshirtDiffuseTexture;
        node.material.roughnessMap = tshirtRoughnessTexture;
        node.material.normalMap = tshirtNormalTexture;
        node.material.color.setHex(0xffffff);

        node.material.envMapIntensity = 0.5;


      }

      if (node.name.includes("HG_Teeth")) {
        morphTargetDictionaryLowerTeeth = node.morphTargetDictionary;
      }

    }

  });

  const [clips, setClips] = useState([]);
  const mixer = useMemo(() => new THREE.AnimationMixer(gltf.scene), []);

  useEffect(() => {

    if (speak === false)
      return;

    makeSpeech(text)
    .then( response => {

      let {blendData, filename}= response.data;
      //console.log("bledndata::::",blendData);
      let newClips = [ 
        createAnimation(blendData, morphTargetDictionaryBody, 'Wolf3D_Avatar') 
        //createAnimation(blendData, morphTargetDictionaryLowerTeeth, 'HG_Teeth') 
      ];

      filename = host + filename;
        
      setClips(newClips);
      setAudioSource(filename);

    })
    .catch(err => {
      console.error(err);
      setSpeak(false);

    })

  }, [speak]);

  let idleFbx = useFBX('/idle15.fbx');
  let { clips: idleClips } = useAnimations(idleFbx.animations);

  idleClips[0].tracks = _.filter(idleClips[0].tracks, track => {
    return track.name.includes("Head") || track.name.includes("Neck") || track.name.includes("Spine2");
  });

  idleClips[0].tracks = _.map(idleClips[0].tracks, track => {

    if (track.name.includes("Head")) {
      track.name = "head.quaternion";
    }

    if (track.name.includes("Neck")) {
      track.name = "neck.quaternion";
    }

    if (track.name.includes("Spine")) {
      track.name = "spine2.quaternion";
    }

    return track;

  });

  useEffect(() => {

    let idleClipAction = mixer.clipAction(idleClips[0]);
    idleClipAction.play();

    let blinkClip = createAnimation(blinkData, morphTargetDictionaryBody, 'HG_Body');
    let blinkAction = mixer.clipAction(blinkClip);
    blinkAction.play();


  }, []);

  // Play animation clips when available
  useEffect(() => {

    if (playing === false)
      return;
    
    _.each(clips, clip => {
        let clipAction = mixer.clipAction(clip);
        clipAction.setLoop(THREE.LoopOnce);
        clipAction.play();

    });

  }, [playing]);

  
  useFrame((state, delta) => {
    mixer.update(delta);
  });


  return (
    <group name="avatar">
      <primitive object={gltf.scene} dispose={null} />
    </group>
  );
}


function makeSpeech(text) {
  return axios.post(host + '/talk', { text });
}

function getPdfText(purl) {
  const pdfurl = "https://vplaysmart.com/wp-content/uploads/2024/05/solar_system.pdf";
  const url  = purl || pdfurl;
  return axios.post(chatbothost + '/pdf/gettext', { filepath: url });
}

function getQuesitions(grade_v) {
  const grade = 9;
  const grade_d  = grade_v || grade;
  return axios.get(vplayhost + '/wp-json/event-manager/v1/get_rag_qa?grade='+grade_d);
}

function getAnswer(purl, quest, ans, cAns) {
	console.log("correctAns:::"+cAns);
  const pdfurl = "https://vplaysmart.com/wp-content/uploads/2024/05/solar_system.pdf";
  const url  = purl || pdfurl;
  return axios.post(chatbothost + '/rag/getanswer', { userans: ans, quesition: quest, answer: cAns });
}

const STYLES = {
  area: {position: 'absolute', top:'10rem', right: '150px', zIndex: 500, width: '23%'},
  text: {margin: '0px', width:'300px', padding: '5px', background: 'none', color: '#ffffff', fontSize: '1.2em', border: 'none'},
  speak: {padding: '10px', marginTop: '5px', display: 'block', color: '#FFFFFF', background: '#222222', border: 'None'},
  area2: {position: 'absolute', top:'5px', right: '15px', zIndex: 500},
  label: {color: '#777777', fontSize:'0.8em'}
}

function App() {

  const audioPlayer = useRef();

  const [speak, setSpeak] = useState(false);
  const [text, setText] = useState("Hey I'm vOne. How may i help you?");
  const [audioSource, setAudioSource] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [phrase, setPhrase] = useState("The shape of DNA is known as?");
  const [listen, setListen] = useState(false);
  const [summary, setSummary] = useState(null);
  const [correctAnswer, setCorrectAnswer] = useState(null);
  const [quesition, setQuesition] = useState(null);
  const [result, setResult] = useState(null);
  const [correctCount, setCorrectCount] = useState(0);
  const [wrongCount, setWrongCount] = useState(0);

  const [queryParams, setQueryParams] = useState({});
  const purl = queryParams.pdfurl;
  const grade_v = queryParams.grade
  const exptype = queryParams.exptype;
  
  let stemdata = 0;
  if(exptype =="stemclub") {
	  stemdata = 1;
  }
  

  var phrases = [
    'punting','crowd','secret','fumble'];
  var grade1_phrase = [
    'sample','sample2'
  ];
  var grade2_phrase = [
    'sample3','sample23'
  ];
  
  useEffect(() => {
    const params = queryString.parse(window.location.search);
    setQueryParams(params);
  }, []);

  // End of play
  function playerEnded(e) {
    setAudioSource(null);
    setSpeak(false);
    setPlaying(false);
    setListen(false);
    setMikeListen();
  }

  // Player is read
  function playerReady(e) {
    audioPlayer.current.audioEl.current.play();
    setPlaying(true);
  }  

  function handleClick() {
    //make the APi Call to get the text
    getPdfText(purl).then( response => {
      console.log("RESPONSE::::::", response);
      setSpeak(true);
      let tData = response.data.text+" ...";
      //tData = tData.replace(/(?:\r\n|\r|\n)/g, '<br />');
      setSummary(tData)
      setText(tData);
      var eone = document.getElementById('evone');
      eone.disabled = true;
      setListen(false);
    })
   
   }
   
   function handleSummary() {
    //make the APi Call to get the text
	  let sData;
	  if(stemdata > 0) {
		 sData = "Corrosion is the gradual deterioration of a material, usually a metal, due to a chemical or electrochemical reaction with its environment. It's a natural process that helps metals return to their more stable oxidation states and forms, such as oxides, hydroxides, or sulfides";
	  } else {
		  sData = "Animals are living things. Like plants, animals need food and water to live. Unlike plants, which make their own food, animals feed themselves by eating plants or other animals. Animals can also sense what goes on around them. Their bodies allow them to move in reaction to their surroundings. They use their senses and movement to find food, mates, and safety. Millions of different kinds of animals live on Earth. Animals are found throughout the world, from the freezing polar zones to the hottest deserts. They live on land and in the water. They come in a huge variety of shapes and sizes. Scientists divide animals into two main groups. Animals that have a backbone are called vertebrates. Animals that do not have a backbone are called invertebrates. About 95 percent of all animals are invertebrates.";
	  }
      setSpeak(true);
      let tData = sData;
      //tData = tData.replace(/(?:\r\n|\r|\n)/g, '<br />');
      setSummary(tData)
      setText(tData);
      var eone = document.getElementById('evone');
      eone.disabled = true;
      setListen(false);
    
   
   }
 
 
   function randomNumber(cnt) {
     var number = Math.floor(Math.random() * cnt);
     return number;
   }
 
  function handleMikeListening() {
    //console.log("QueryParams:::",queryParams.level)
   
    getQuesitions(purl).then( response => {
      //console.log(response.data.length);
	  let tcnt = response.data.length;
	  let randNo = randomNumber(tcnt+1);
      let res_data = response.data[randNo];
	  //console.log("QUESITION:::"+phraseTxtData.quesition)
	  let phraseTxtData = res_data.quesition;
	  let correctAns = res_data.answer;
	  //console.log("MY CORRECt ANS::::"+correctAns);
      setSpeak(true);
      setText(phraseTxtData);
      setQuesition(phraseTxtData);
	  setCorrectAnswer(correctAns);
      setListen(true);
      phraseTxtData = null;
	  correctAns = null;
	  if(attempts>0) {
		  attempts=0;
	  }
    })
  }
  
  function handleRetry() {
	if(attempts > 0 && attempts <=3) {
		setSpeak(true);
		setText(quesition);
		//setListen(true);
	}
  }
  
 
  function setMikeListen() {
     //console.log("In setMike Listen",phrase);
     var testBtn = document.getElementById('testBtn');
     var recognition = new SpeechRecognition();
     recognition.start();
     var speechRecognitionList = new SpeechGrammarList();
     var grammar = '#JSGF V1.0; grammar phrase; public <phrase> = ' + phrase +';';
     speechRecognitionList.addFromString(grammar, 1);
     recognition.grammars = speechRecognitionList;
     recognition.lang = 'en-US';
     recognition.continuous = true;
     recognition.interimResults = false;
     recognition.maxAlternatives = 1;
     //startTimer();	
     recognition.onresult = function(event) {
       // The SpeechRecognitionEvent results property returns a SpeechRecognitionResultList object
       // The SpeechRecognitionResultList object contains SpeechRecognitionResult objects.
       // It has a getter so it can be accessed like an array
       // The first [0] returns the SpeechRecognitionResult at position 0.
       // Each SpeechRecognitionResult object contains SpeechRecognitionAlternative objects that contain individual results.
       // These also have getters so they can be accessed like arrays.
       // The second [0] returns the SpeechRecognitionAlternative at position 0.
       // We then return the transcript property of the SpeechRecognitionAlternative object 
     var speechResult = event.results[0][0].transcript.toLowerCase();
       console.log("SPEECH SPOKEN::::",speechResult);
       console.log("QUESITONS::::",quesition);
       //setUserSpokenWord(speechResult);
       
       //setCorrectAnswer(correctAnswer);
       if(speechResult.includes("repeat")) {
        setSpeak(true);
        setText(quesition);
        return false;
      }

      getAnswer(purl,quesition, speechResult, correctAnswer).then( response => {
        setSpeak(true);
        setText(response.data);
        setResult(response.data);
		let resData = response.data;
		if(resData.includes("Correct"))
			{
			correct_count++;
			setCorrectCount(correct_count);
		} else {
			wrong_count++;
			setWrongCount(wrong_count);
			attempts++;
		}
		if(attempts<3) {
			testBtn.disabled = true;
		} else {
			testBtn.disabled = false;
		}
		
      })
	  
       console.log('Confidence: ' + event.results[0][0].confidence);
     }
 
     recognition.onspeechend = function() {
       recognition.stop();
       testBtn.disabled = false;
       testBtn.textContent = 'Next Quesition';       
     }
 
     recognition.onerror = function(event) {
       testBtn.disabled = false;
       testBtn.textContent = 'Start vOne Again!!';
     }
     
     recognition.onaudiostart = function(event) {
         //Fired when the user agent has started to capture audio.
         console.log('SpeechRecognition.onaudiostart');
     }
     
     recognition.onaudioend = function(event) {
         //Fired when the user agent has finished capturing audio.
         console.log('SpeechRecognition.onaudioend');
     }
     
     recognition.onend = function(event) {
         //Fired when the speech recognition service has disconnected.
         console.log('SpeechRecognition.onend');
         //testBtn.click();
     }
     
     recognition.onnomatch = function(event) {
         //Fired when the speech recognition service returns a final result with no significant recognition. This may involve some degree of recognition, which doesn't meet or exceed the confidence threshold.
         console.log('SpeechRecognition.onnomatch');
     }
     
     recognition.onsoundstart = function(event) {
         //Fired when any sound — recognisable speech or not — has been detected.
         console.log('SpeechRecognition.onsoundstart');
     }
     
     recognition.onsoundend = function(event) {
         //Fired when any sound — recognisable speech or not — has stopped being detected.
         console.log('SpeechRecognition.onsoundend');
     }
     
     recognition.onspeechstart = function (event) {
         //Fired when sound that is recognised by the speech recognition service as speech has been detected.
         console.log('SpeechRecognition.onspeechstart');
     }
     recognition.onstart = function(event) {
         //Fired when the speech recognition service has begun listening to incoming audio with intent to recognize grammars associated with the current SpeechRecognition.
         console.log('SpeechRecognition.onstart');
     }
  }
  return (
    <div className="full">
      <div id="right-section" style={STYLES.area}>
        {/*<textarea rows={4} type="text" style={STYLES.text} value={text} onChange={(e) => setText(e.target.value.substring(0, 200))} />
        <button onClick={() => setSpeak(true)} style={STYLES.speak}> { speak? 'Running...': 'Speak' }</button>*/}
        <div className="button-sections">
		  <button id="evone" onClick={handleSummary} style={STYLES.speak}> { speak? 'Running...': 'Summerize the text' }</button>&nbsp;&nbsp;
          {stemdata < 1 && <span className="bdata">
			  <button id="testBtn" onClick={handleMikeListening} style={STYLES.speak}> { listen? 'vOne Processing...': 'Start the Quesitions' }</button>&nbsp;&nbsp;
			  <button id="retry" onClick={handleRetry} style={STYLES.speak}> { listen? 'Retry': 'Retry' }</button></span>
		  }
        </div>
        <div id="user-vone-inputs">
		  <div id="uinput"><b>Summary:</b> 
		  <ReadMoreArea lettersLimit={100}>
			{summary}
		  </ReadMoreArea></div>
		  {stemdata < 1 && <span>
			  <div id="cquestr"><b>Quesition</b>: {quesition}</div>
			  <div id="canswer"><b>Result</b>: {result}</div></span>
		  }
        </div>
		{attempts >0 &&
				<div id="retry-attempt">You tried attempt {attempts} of 3</div>
		}
		{stemdata < 1 &&
		   <div id="user-score">
			  <div id="rightcount">Correct: {correctCount}</div>
			  <div id="wrongcount">Wrong: {wrongCount}</div>
			</div>
		}
      </div>

      <ReactAudioPlayer
        src={audioSource}
        ref={audioPlayer}
        onEnded={playerEnded}
        onCanPlayThrough={playerReady}
        
      />
      
      {/* <Stats /> */}
    <Canvas dpr={2} onCreated={(ctx) => {
        ctx.gl.physicallyCorrectLights = true;
      }}>

      <OrthographicCamera 
      makeDefault
      zoom={1000}
      position={[0.4, 1.55, 1]}
      />

      {/* <OrbitControls
        target={[0, 1.65, 0]}
      /> */}

      <Suspense fallback={null}>
        <Environment background={false} files="/images/photo_studio_loft_hall_1k.hdr" />
      </Suspense>

      <Suspense fallback={null}>
        <Bg />
      </Suspense>

      <Suspense fallback={null}>



          <Avatar 
            avatar_url="/model15.glb" 
            speak={speak} 
            setSpeak={setSpeak}
            text={text}
            setAudioSource={setAudioSource}
            playing={playing}
            />

      
      </Suspense>

  

  </Canvas>
  <Loader dataInterpolation={(p) => `Loading... please wait`}  />
  </div>
  )
}

function Bg() {
  
  const texture = useTexture('/images/bg1.webp');

  return(
    <mesh position={[0.36, 1.6, -2]} scale={[0.6, 0.6, 0.6]}>
      <planeBufferGeometry />
      <meshBasicMaterial map={texture} />
    </mesh>
  )

}

export default App;
